import { UserType } from './user-roles';

export class ChangelogVersion {
  versionName: string = '';
  changes?: string[] = [];
  fixes?: string[] = [];
  restrictedChanges?: ChangeRow[] = [];
  restrictedFixes?: ChangeRow[] = [];
  constructor(changelogVersion?: ChangelogVersion) {
    Object.assign(this, changelogVersion);
  }
}
class ChangeRow {
  roles: UserType | UserType[];
  changes: string[];
}

export const ChangeLog: ChangelogVersion[] = [
  new ChangelogVersion({
    versionName: '2.18.39',
    changes: [
      'Monthly license in digressive pricing.',
      'Upgrade of underlying framework (Angular)'
    ],
    fixes: [
      'Fix bug where "Show package" was showing when no package was defined.',
      "Fix issue where operator package list isn't updated without refreshing when creating a new package."
    ],
    restrictedFixes: [
      {
        roles: UserType.Admin,
        changes: [
          'Ability to change the operator package associated with a client package.',
          'Changelogs for operator packages and client operator packages.',
          'Ability to filter by country on operator packages.'
        ]
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.18.6',
    changes: ['Icons in menu!', 'New '],
    fixes: [],
    restrictedFixes: [
      {
        roles: UserType.Admin,
        changes: ['Operator info can now be changed']
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.18.2',
    changes: [
      'Operators may start charging as the box owner without searching for the user',
      'Operators may add points directly from the point list. The function will autoselect the location.',
      'Operators may now add locations owned by a company',
      'If a company does not exist in SmartCharge, it can be semi-added by the operator. The owner will then be asked by email to complete the registration',
      'The owner of a lcoation is listed in location info',
      'Support information related to a location is listen in location info'
    ],
    fixes: [],
    restrictedFixes: [
      {
        roles: UserType.Admin,
        changes: ['Operator info can now be changed']
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.18.0',
    changes: [
      'Added export of ALL location reports, not just the last 10',
      'Payouts from SmartCharge are added to the billing page',
      'Added limits to some fields in company information'
    ],
    fixes: [],
    restrictedChanges: [
      {
        roles: UserType.Admin,
        changes: [
          'Added possibility to change due date of invoice for admins',
          'Company page with company info, payments, locations, invoices and billing overview',
          'Export companies',
          'Added locations to operators with export',
          'Added settings/info to operators'
        ]
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.17.20',
    changes: [],
    fixes: ['Fixed a problem with packages in add location']
  }),
  new ChangelogVersion({
    versionName: '2.17.19',
    changes: [
      'Different package selector when adding location. Easer to use when there are many packages'
    ],
    restrictedChanges: [
      {
        roles: UserType.Admin,
        changes: ['Payments to companies', 'Download payment']
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.17.18',
    fixes: ['Fixed a bug in reports'],
    changes: [
      'Connectivity bar to see the stability of a point for the last 24h'
    ]
  }),
  new ChangelogVersion({
    versionName: '2.17.17',
    fixes: [
      'Fixed a problem when selecting january in analytics causing the analytics to be shown for the current date'
    ],
    changes: ['Box response (eg. accepted or rejected) will show in actions'],
    restrictedChanges: [
      {
        roles: UserType.Admin,
        changes: [
          'New refunding functionality',
          'New changelog page that takes any input'
        ]
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.17.16',
    fixes: ['Fixed a problem related to adding boxes and fuse beeing empty'],
    restrictedChanges: [
      {
        roles: UserType.Admin,
        changes: [
          'Added changelog to companies',
          'Added companyID to location info'
        ]
      }
    ],
    restrictedFixes: [
      {
        roles: UserType.Admin,
        changes: ['Fixed an issue with editing box models']
      }
    ]
  }),
  new ChangelogVersion({
    versionName: '2.17.15',
    changes: [
      'New branding',
      '"Location report" is added. It shows debited payments per month and is the basis of payouts',
      '"BI report" is replaced with "Point usage report"',
      'Possibility to always modify billing information'
    ],
    fixes: [
      'Cleaned up differences with box fuse and point power settings when adding a point/box',
      'Tooltips was not always working in actions',
      'Localized PLUG_AND_CHARGE in actions'
      /*{
                roles: [...UserType.Admin],
                text: 'Hello'
            }*/
    ],
    restrictedChanges: [
      {
        roles: UserType.Admin,
        changes: ['Pending payouts']
      }
    ]
  })
];
